import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(".nested-fields")
    if (!wrapper) return

    const isNew = wrapper.dataset.newRecord === "true" || wrapper.dataset.newRecord === true
    if (isNew) {
      wrapper.remove()
      return
    }

    const hidden = wrapper.querySelector("input[type='hidden'][name$='[_destroy]']")
    if (hidden) hidden.value = "1"
    wrapper.style.display = "none"
  }
}
